import React from 'react'
import BizInfoSkeletonStyle from '../style/BizInfoSkeleton.module.css';
const BizInfoSkeleton = () => {
    return (
        <>
            <div className='row'>
                <div className='col-md-12'>
                    <div className='card'>
                        <div className='card-body'>
                            <div className='row'>
                                <div className='col-md-8'>
                                    <div className={`${BizInfoSkeletonStyle.skeleton} ${BizInfoSkeletonStyle.skeletonTitle}`}></div>
                                    <div className={`${BizInfoSkeletonStyle.skeleton} ${BizInfoSkeletonStyle.skeletonSubtitle}`}></div>
                                    <div className={`${BizInfoSkeletonStyle.skeletonRow}`}>
                                        <div>
                                            <div className={`${BizInfoSkeletonStyle.skeleton} ${BizInfoSkeletonStyle.skeletonBox}`}></div>
                                            <div className={`${BizInfoSkeletonStyle.skeleton} ${BizInfoSkeletonStyle.skeletonBox}`} style={{width:'60px'}}></div>
                                        </div>
                                        <div>
                                            <div className={`${BizInfoSkeletonStyle.skeleton} ${BizInfoSkeletonStyle.skeletonBox}`} style={{width:'80px'}}></div>
                                            <div className={`${BizInfoSkeletonStyle.skeleton} ${BizInfoSkeletonStyle.skeletonBox}`} style={{width:'100px'}}></div>
                                        </div>
                                    </div>
                                    <div className={`${BizInfoSkeletonStyle.skeleton} ${BizInfoSkeletonStyle.skeletonBox}`} style={{width:'140px', marginBottom:'10px'}}></div>
                                    <div className={`${BizInfoSkeletonStyle.skeletonRow}`}>
                                        <div className={`${BizInfoSkeletonStyle.skeleton} ${BizInfoSkeletonStyle.skeletonEmail}`}></div>
                                        <div className={`${BizInfoSkeletonStyle.skeleton} ${BizInfoSkeletonStyle.skeletonAddress}`}></div>
                                    </div>
                                </div>
                                <div className='col-md-4'>
                                    <div style={{textAlign:'right'}}>
                                        <div className={`${BizInfoSkeletonStyle.skeleton} ${BizInfoSkeletonStyle.skeletonCredit}`}></div>
                                        <div className={`${BizInfoSkeletonStyle.skeleton} ${BizInfoSkeletonStyle.skeletonAmount}`}></div>
                                        <div className={`${BizInfoSkeletonStyle.skeleton} ${BizInfoSkeletonStyle.skeletonDate}`}></div>
                                        <div className={`${BizInfoSkeletonStyle.skeleton} ${BizInfoSkeletonStyle.skeletonDate}`}></div>
                                        <div className={`${BizInfoSkeletonStyle.skeleton} ${BizInfoSkeletonStyle.skeletonButton} mt-10`}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default BizInfoSkeleton